module.exports = __webpack_public_path__ + "static/media/12UNCTAD19.eebc4f40.jpg";